// Todo Delete Old Interface:
// export interface IProgressResponse {
// 	calculate?: number;
// 	capexs?: number;
// 	fundings?: number;
// 	general_data?: number;
// 	sales_and_opexs?: number;
// 	taxes?: number;
// }
export const ItemProgressSet = new Set(['calculate', 'capexs', 'fundings', 'general_data', 'sales_and_opexs', 'taxes']);

type ValidatedTabs = {
  [key in TabName]?: boolean;
};

type TabName =
  | 'own_funds'
  | 'credits'
  | 'leasings'
  | 'working_capitals'
  | 'products'
  | 'opexs'
  | 'capexs'
  | 'taxs'
  | 'discount_rates';
export type ItemProgressKey = 'general_data' | 'calculate' | 'fundings' | 'sales_and_opexs' | 'capexs' | 'taxes';
export enum ItemProgressEnum {
  'calculate' = 'calculate',
  'capexs' = 'capexs',
  'fundings' = 'fundings',
  'general_data' = 'general_data',
  'sales_and_opexs' = 'sales_and_opexs',
  'taxes' = 'taxes',
}

type Item = {
  [key in ItemProgressKey]?: number;
};

type Item2 = {
  is_valid: boolean;
  validated_tabs: ValidatedTabs;
};

export type IProgressResponseItem = Item & Item2;

export type IProgressResponse = IProgressResponseItem[];
